<template>
  <v-row :class="{ 'read-only-selector': readonly }">
    <!-- ✅ LISTADO EMPLAZAMIENTOS (SIN REPETIR) -->
    <v-col cols="4">
      
      <v-list>
        <p class="pl-8 info-expediente">
          {{ $t('selectEmplazamientoProductos.emplazamientos') }}
        </p>
        <!-- TODOS -->
        <template v-if="!readonly">
          <v-list-item @click.stop="onToggleTodos">
            <v-list-item-action>
              <v-checkbox :input-value="checkTodos" :color="subalcance.color" :readonly="readonly" />
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Todos los emplazamientos</v-list-item-title>
              <v-list-item-subtitle>
                Selecciona todos los productos de todos los grids
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />
        </template>

        <!-- EMPLAZAMIENTOS -->
        <v-list-item
          v-for="empl in emplazamientosUnicos"
          :key="empl.uuid"
          @click.stop="onToggleEmplazamiento(empl)"
        >
          <v-list-item-action>
            <v-checkbox
              :input-value="emplazamientosSeleccionados.includes(empl.uuid)"
              :color="subalcance.color"
              :readonly="readonly"
            />
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ empl.nombre }}</v-list-item-title>
            <v-list-item-subtitle class="text-truncate">
              {{ empl.nombreGrid || '—' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-col>

    <!-- ✅ TABS POR GRID (DEFINE ALCANCE) -->
    <v-col cols="8">
      <v-tabs v-model="tabGridUuid" :color="subalcance.color" :slider-color="subalcance.color">
        <v-tab v-for="g in gridsDefineAlcance" :key="g.uuid" :href="'#' + g.uuid">
          <span class="primary--text text-no-wrap text-truncate">{{ g.nombre }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabGridUuid">
        <v-tab-item v-for="g in gridsDefineAlcance" :key="g.uuid" :value="g.uuid">
          <v-row class="mt-3">
            <v-data-table
              :headers="headersPorGrid(g)"
              :items="productosPorGrid(g.uuid)"
              :items-per-page="5"
              show-select
              item-key="uuid"
              class="elevation-1"
              :no-data-text="$t('tabla.sindatos')"
              :footer-props="{ 'items-per-page-text': $t('tabla.filasporpagina') }"
              :checkbox-color="subalcance.color"
              :value="selectedItemsForGrid(g.uuid)"
              @input="onTableSelection(g.uuid, $event)">
              <!-- RGSEAA (columna fija) -->
              <template v-slot:item.__rgseaa="{ item }">
                {{ item?.emplazamiento?.direccion?.rgseaa ?? '-' }}
              </template>

              <!-- Render dinámico de columnas del grid -->
              <template
                v-for="h in headersPorGrid(g).filter((x) => x.value !== '__emplazamiento')"
                v-slot:[`item.${h.value}`]="{ item }">
                {{ itemParamDisplay(item, h.value) }}
              </template>
            </v-data-table>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
function sameArray(a = [], b = []) {
  if (a.length !== b.length) return false
  return a.every((v, i) => v === b[i])
}

function sameSet(a = new Set(), b = new Set()) {
  if (a.size !== b.size) return false
  for (const v of a) if (!b.has(v)) return false
  return true
}
export default {
  props: {
    valueEmplazamientos: {
      type: Array,
      default: () => [],
    },
    valueProductos: {
      type: Array,
      default: () => [],
    },
    //emplazamientos: { type: Array, default: () => [] }, ahora se toma toda la data desde productos
    productos: { type: Array, default: () => [] },
    subalcance: { type: Object, required: true },
    gruposConfig: { type: Array, default: () => [] },
    soloOrigenIteracion: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabGridUuid: '',
      // ✅ estos 2 arrays SON la selección cruzada
      emplazamientosSeleccionados: [], // uuids
      selectedProductUuids: new Set(), // uuids (global, todos los grids)
    }
  },

  computed: {
    productosIteraciones() {
      const productos = this.productos || []
      if (!this.soloOrigenIteracion) return productos

      return productos.filter((p) => p?.origenModulo === 'iteraciones')
    },
    checkTodos() {
      return (
        this.emplazamientosSeleccionados.length > 0 &&
        this.emplazamientosSeleccionados.length === this.emplazamientosUnicos.length
      )
    },
    // ✅ si iteracionSelected.emplazamientos viene vacío, los saco de productos (tu caso real)
    emplazamientosUnicos() {
      const map = new Map()

      ;(this.productosIteraciones || []).forEach(p => {
        const empl = p?.emplazamiento
        const dir = empl?.direccion
        const grid = empl?.subalcanceConfig

        if (!dir?.uuid || !grid?.uuid) return

        // 🔑 clave compuesta: direccion + grid
        const key = `${dir.uuid}__${grid.uuid}`

        if (!map.has(key)) {
          map.set(key, {
            uuid: key, // uuid lógico para la UI
            direccionUuid: dir.uuid,
            gridUuid: grid.uuid,
            nombre: dir.nombre || '—',
            tipo: dir.tipo || null,
            nombreGrid: grid.nombre || 'Grid',
          })
        }
      })

      const gridsOrden = this.gridsDefineAlcance.reduce((acc, g, idx) => {
        acc[g.uuid] = idx
        return acc
      }, {})

      return Array.from(map.values()).sort((a, b) => {
        // 1️⃣ orden del grid
        const ogA = gridsOrden[a.gridUuid] ?? 999
        const ogB = gridsOrden[b.gridUuid] ?? 999
        if (ogA !== ogB) return ogA - ogB

        // 2️⃣ nombre del grid
        const ng = a.nombreGrid.localeCompare(b.nombreGrid, 'es', { sensitivity: 'base' })
        if (ng !== 0) return ng

        // 3️⃣ nombre del emplazamiento
        return a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      })
    },

    // ✅ grids que DEFINEN ALCANCE (tabs)
    gridsDefineAlcance() {
      const grids = new Map()

      // 1️⃣ localizar todos los grids que definen alcance
      ;(this.gruposConfig || []).forEach(grupo => {
        ;(grupo.subalcanceConfigs || []).forEach(sc => {
          if (sc.tipo === 'grid' && sc.defineAlcance && sc.uuid) {
            grids.set(sc.uuid, {
              uuid: sc.uuid,
              nombre: sc.nombre || 'Grid',
              orden: sc.orden ?? 9999,
              columnas: []
            })
          }
        })
      })

      // 2️⃣ columnas propias de cada grid (gridConfig)
      grids.forEach(grid => {
        const sc = this.gruposConfig
          .flatMap(g => g.subalcanceConfigs || [])
          .find(s => s.uuid === grid.uuid)

        if (!sc || !Array.isArray(sc.gridConfig)) return

        sc.gridConfig
          .filter(c => c.define_alcance)
          .forEach(c => {
            grid.columnas.push({
              nombre: c.nombre,
              tipo: c.tipo,
              orden: c.orden ?? 9999
            })
          })
      })

      // 3️⃣ subalcanceConfigs NO grid que definen alcance
      ;(this.gruposConfig || []).forEach(grupo => {
        ;(grupo.subalcanceConfigs || []).forEach(sc => {
          if (sc.tipo === 'grid') return
          if (!sc.defineAlcance) return

          const targets = sc.gruposDondeDefineAlcance || []

          grids.forEach(grid => {
            if (
              targets.includes('all') ||
              targets.includes(grid.uuid)
            ) {
              grid.columnas.push({
                nombre: sc.nombre,
                tipo: sc.tipo,
                orden: sc.orden ?? 9999
              })
            }
          })
        })
      })

      // 4️⃣ ordenar columnas y devolver array ordenado
      return Array.from(grids.values())
        .map(g => ({
          ...g,
          columnas: g.columnas.sort((a, b) => a.orden - b.orden)
        }))
        .sort((a, b) => a.orden - b.orden)
    },

    // ✅ productos seleccionados (objetos) para emitir al padre
    selectedProductosObjetos() {
      const ids = this.selectedProductUuids
      return (this.productosIteraciones || []).filter((p) => p?.uuid && ids.has(p.uuid))
    },
  },

  watch: {
    gridsDefineAlcance: {
      immediate: true,
      handler(grids) {
        if (!this.tabGridUuid && grids.length) {
          this.tabGridUuid = grids[0].uuid
        }
      }
    },
    valueEmplazamientos: {
      immediate: true,
      handler(val) {
        const next = Array.isArray(val) ? [...val] : []
        if (!sameArray(next, this.emplazamientosSeleccionados)) {
          this.emplazamientosSeleccionados = next
        }
      },
    },
    valueProductos: {
      immediate: true,
      deep: true,
      handler(val) {
        const nextIds = new Set(
          (Array.isArray(val) ? val : [])
            .map((producto) => this.productUuid(producto))
            .filter(Boolean)
        )

        if (!sameSet(nextIds, this.selectedProductUuids)) {
          this.selectedProductUuids = nextIds
        }
      },
    },

    emplazamientosSeleccionados: {
      deep: true,
      handler(val) {
        if (!sameArray(val, this.valueEmplazamientos)) {
          this.$emit('update:valueEmplazamientos', val)
        }
      },
    },

    selectedProductosObjetos: {
      deep: true,
      handler(val) {
        this.$emit('update:valueProductos', val)
      },
    },
  },

  methods: {
    productUuid(producto) {
      if (!producto) return null
      if (typeof producto === 'string') {
        const parts = producto.split('/')
        return parts[parts.length - 1] || null
      }
      return producto.uuid || null
    },
    onToggleTodos() {
      if (this.readonly) return
      this.toggleTodos()
    },
    onToggleEmplazamiento(empl) {
      if (this.readonly) return
      this.toggleEmplazamiento(empl)
    },
    toggleTodos() {
      if (this.checkTodos) {
        // desmarcar todos
        this.emplazamientosSeleccionados = []
        this.selectedProductUuids = new Set()
      } else {
        // marcar todos
        this.emplazamientosSeleccionados = this.emplazamientosUnicos.map(e => e.uuid)

        const allIds = new Set()
        ;(this.productosIteraciones || []).forEach(p => {
          if (p?.uuid) allIds.add(p.uuid)
        })
        this.selectedProductUuids = allIds
      }
    },
    // ======================
    //   HELPERS DE RENDER
    // ======================
    productosPorGrid(gridUuid) {
      return (this.productosIteraciones || []).filter(
        p => p?.emplazamiento?.subalcanceConfig?.uuid === gridUuid
      )
    },

    headersPorGrid(grid) {
      return [
        {
          text: 'RGSEAA',
          value: '__rgseaa',
          sortable: false,
        },
        ...(grid.columnas || []).map(c => ({
          text: c.nombre,
          value: c.nombre,
          sortable: false,
        }))
      ]
    },

    itemParam(item, nombre) {
      const params = Array.isArray(item?.params) ? item.params : []
      return params.find((p) => p?.nombre === nombre) || null
    },

    itemEmplazamientoDisplay(item) {
      const params = Array.isArray(item?.params) ? item.params : []
      const p = params.find((x) => x?.tipo === 'emplazamiento')
      return p?.displayValue || ''
    },

    itemParamDisplay(item, nombreHeader) {
      const p = this.itemParam(item, nombreHeader)
      if (!p) return '—'

      // emplazamiento -> displayValue
      if (p.tipo === 'emplazamiento') return p.displayValue || '—'

      // array
      if (Array.isArray(p.valor)) {
        if (!p.valor.length) return '—'
        // array de objetos
        if (p.valor[0] && typeof p.valor[0] === 'object') {
          const txt = p.valor[0].nombre || p.valor[0].texto || p.valor[0].razonSocial
          return txt || '—'
        }
        // array plano
        return p.valor.join(', ')
      }

      // valor suelto
      if (p.valor === null || p.valor === undefined || p.valor === '') return '—'
      return String(p.valor)
    },

    // ======================
    //   SELECCIÓN CRUZADA
    // ======================
    toggleEmplazamiento(empl) {
      const key = empl.uuid
      const idx = this.emplazamientosSeleccionados.indexOf(key)
      const selected = idx !== -1

      if (selected) {
        this.emplazamientosSeleccionados.splice(idx, 1)

        this.productosIteraciones.forEach(p => {
          if (
            p?.emplazamiento?.direccion?.uuid === empl.direccionUuid &&
            p?.emplazamiento?.subalcanceConfig?.uuid === empl.gridUuid &&
            p?.uuid
          ) {
            this.selectedProductUuids.delete(p.uuid)
          }
        })
      } else {
        this.emplazamientosSeleccionados.push(key)

        this.productosIteraciones.forEach(p => {
          if (
            p?.emplazamiento?.direccion?.uuid === empl.direccionUuid &&
            p?.emplazamiento?.subalcanceConfig?.uuid === empl.gridUuid &&
            p?.uuid
          ) {
            this.selectedProductUuids.add(p.uuid)
          }
        })
      }

      this.selectedProductUuids = new Set(this.selectedProductUuids)
    },

    selectedItemsForGrid(gridUuid) {
      const items = this.productosPorGrid(gridUuid)
      const ids = this.selectedProductUuids
      return items.filter((p) => p?.uuid && ids.has(p.uuid))
    },

    onTableSelection(gridUuid, selectedItems) {
      if (this.readonly) return

      const gridItems = this.productosPorGrid(gridUuid)

      const selectedIds = new Set(
        (selectedItems || []).map(p => p?.uuid).filter(Boolean)
      )

      // 1️⃣ sincroniza SOLO los productos de este grid
      gridItems.forEach(p => {
        if (!p?.uuid) return
        if (selectedIds.has(p.uuid)) {
          this.selectedProductUuids.add(p.uuid)
        } else {
          this.selectedProductUuids.delete(p.uuid)
        }
      })

      // 2️⃣ recalcula emplazamientos (dirección + grid)
      const afectados = new Map()

      gridItems.forEach(p => {
        const dirUuid = p?.emplazamiento?.direccion?.uuid
        const gridUuid = p?.emplazamiento?.subalcanceConfig?.uuid
        if (!dirUuid || !gridUuid) return

        const key = `${dirUuid}__${gridUuid}`
        if (!afectados.has(key)) {
          afectados.set(key, { dirUuid, gridUuid })
        }
      })

      afectados.forEach(({ dirUuid, gridUuid }, key) => {
        const tieneProductos = this.productosIteraciones.some(
          p =>
            p?.emplazamiento?.direccion?.uuid === dirUuid &&
            p?.emplazamiento?.subalcanceConfig?.uuid === gridUuid &&
            this.selectedProductUuids.has(p.uuid)
        )

        const idx = this.emplazamientosSeleccionados.indexOf(key)

        if (tieneProductos && idx === -1) {
          this.emplazamientosSeleccionados.push(key)
        }

        if (!tieneProductos && idx !== -1) {
          this.emplazamientosSeleccionados.splice(idx, 1)
        }
      })

      // 3️⃣ fuerza reactividad del Set
      this.selectedProductUuids = new Set(this.selectedProductUuids)
    },
  },
  mounted() {
    //console.log('PARAMS PRODUCTO EJEMPLO:', this.productosIteraciones)
  },
}
</script>

<style scoped>
.read-only-selector .info-expediente {
  margin-bottom: 4px;
}

.read-only-selector .v-input--selection-controls {
  pointer-events: none;
}

.read-only-selector .v-data-table__checkbox {
  pointer-events: none;
}
</style>
